import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { detect, BrowserInfo, Browser } from 'detect-browser';

import { getLangKey } from 'models/Language';
import {
  browserConfig,
  BrowserConfigType
} from 'components/onboarding/extensionConfig';
import ExtensionInstallButton from 'components/onboarding/install_button';

import * as translations from '../strings';
import { STEP_PATHS, WizardStep } from '../types';
import styles from '../index.module.css';

// Shown instead of InstallBugHerd when the user opted into the demo site.
// BugHerd is already loaded on the demo site via the project's API key, so
// there's nothing to install here — we just recommend the browser extension
// for the user's own sites and let them skip straight to trying it out.
const InstallBugHerdDemo: React.FC = () => {
  const strings = translations[getLangKey()];
  const navigate = useNavigate();

  const browser = detect() as BrowserInfo;
  const currentBrowser: Browser | null = browser ? browser.name : null;
  const browserExtensionConfig: BrowserConfigType | null =
    (browserConfig.find(
      info => info.name === currentBrowser
    ) as BrowserConfigType) || null;

  const goToTryStep = () => navigate(STEP_PATHS[WizardStep.TRY]);

  return (
    <>
      <div className={styles.stepPill}>STEP 2</div>
      <h2 className={styles.stepHeading}>{strings.installDemoHeading}</h2>
      <p className={styles.installBody}>{strings.installDemoBody}</p>

      <div className={styles.demoInstallActions}>
        <div className={styles.extensionButtonWrap}>
          <ExtensionInstallButton
            browserConfig={browserExtensionConfig}
            isSignUpOnBoarding
          />
        </div>
        <Button
          type="link"
          onClick={goToTryStep}
          className={styles.demoSkipLink}
        >
          {strings.installDemoSkip}
        </Button>
      </div>
    </>
  );
};

export default InstallBugHerdDemo;
